/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Skip_SaveInputs */

const vi_einvoice_skip_save = /** @type {(inputs: Einvoice_Skip_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu`)
};

/**

* @param {Einvoice_Skip_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skip_save = /** @type {((inputs?: Einvoice_Skip_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skip_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skip_save(inputs)
});